class Semaphore {
  constructor(maxCount) {
    this.count = maxCount;
    this._queue  = [];
  }

  async runExclusion(callback) {
    const value = await this._getTicket();
    try {
      return await callback(value);
    } finally {
      this._release();
    }
  }

  isLocked() {
    return this.count === 0;
  }

  _getTicket() {
    const ticket = new Promise((resolve, reject) =>
      this._queue.push({ resolve, reject })
    );
    if (!this.isLocked()) {
      this._ticketResolve();
    }
    return ticket;
  }

  _ticketResolve() {
    const ticket = this._queue.shift();
    if (!ticket) {
      return;
    }
    this.count--;
    ticket.resolve(this.count);
  }

  _release() {
    this.count++;
    this._ticketResolve();
  }
}

export default Semaphore;